import axios from "axios";

// // Use relative URL to leverage Vite proxy
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_BASE_URL = "/api/v1";
export const getDoctors = async (accountId) => {
    try {
        const url = accountId 
            ? `${API_BASE_URL}/doctors/${accountId}`
            : `${API_BASE_URL}/doctors`;
        const response = await axios.get(url);
        // Ensure consistent return type (always an array)
        return response.data?.doctors || [];
    } catch (error) {
        console.error("Error fetching doctors:", error);
        throw error;
    }
};

export const getDoctorsByAccountId = async (accountId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/doctors/${accountId}`);
      
        return {
            displayname: response.data?.displayname || "",
            doctors: response.data?.doctors || [],
        };
    } catch (error) {
        console.error("Error fetching doctors by account_id:", error);
        throw error;
    }
};

export const createDoctor = async (doctorData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/doctors`, doctorData);
        console.log("✅ Doctor created successfully:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error creating doctor:", error.response?.data || error.message);
        throw error;
    }
};

export const updateDoctor = async (id, doctorData, accountId) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/doctors/${accountId}/${id}`, doctorData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating doctor:", error);
        throw error.response?.data || { message: "Failed to update doctor" };
    }
};

export const deleteDoctors = async (ids, accountId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/doctors/${accountId}`, {
            data: { ids }, // send array of IDs in body
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting doctors:", error);
        throw error.response?.data || { error: "Failed to delete doctors" };
    }
};